var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.enoughGroupsExist)?_c('GroupSelector',{attrs:{"groups":_vm.marketGroups,"selected":_vm.realSelectedMarketGroupId},on:{"valueChanged":_vm.setMarketGroup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c7ae97","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/eventGrid/components/MarketGroups.vue
// module id = 1941
// module chunks = 0